/**
 * Contact フォームのユーザビリティ向上
 * 
 * - ローディング状態の表示
 * - 送信ボタンの無効化
 * - 文字数カウント表示
 */

(function() {
    'use strict';

    // DOMContentLoadedイベントで実行
    document.addEventListener('DOMContentLoaded', function() {
        const form = document.querySelector('form[action="send.php"]');
        if (!form) return;

        // フォームとすべての入力フィールドにdir="ltr"を強制的に設定（カーソル位置の修正）
        form.setAttribute('dir', 'ltr');
        const allInputs = form.querySelectorAll('input, textarea');
        allInputs.forEach(function(input) {
            input.setAttribute('dir', 'ltr');
            input.style.direction = 'ltr';
            input.style.textAlign = 'left';
            // プレースホルダーも明示的に設定
            if (input.placeholder) {
                input.setAttribute('dir', 'ltr');
            }
        });

        const submitButton = form.querySelector('button[type="submit"]');
        const messageField = form.querySelector('#message');
        const validatedFields = form.querySelectorAll('[data-validate="true"]');
        
        // フォーム送信時の処理
        form.addEventListener('submit', function(e) {
            let allValid = true;
            validatedFields.forEach((field) => {
                if (!validateField(field, true)) {
                    allValid = false;
                }
            });

            if (!allValid) {
                e.preventDefault();
                return;
            }

            // フォームのバリデーションが通っている場合のみ実行
            if (!form.checkValidity()) {
                return;
            }

            // 送信ボタンを無効化
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = '送信中...';
                submitButton.classList.add('loading');
            }

            // ローディングインジケーターを追加
            addLoadingIndicator();
        });

        // 各フィールドにリアルタイムバリデーションを設定
        validatedFields.forEach((field) => {
            field.addEventListener('input', () => validateField(field, false));
            field.addEventListener('blur', () => validateField(field, true));
        });

        // メッセージフィールドの文字数カウント
        if (messageField) {
            const maxLength = parseInt(messageField.getAttribute('maxlength')) || 2000;
            const helpText = form.querySelector('.help-text');
            
            // 文字数カウント要素を作成
            const charCount = document.createElement('span');
            charCount.className = 'char-count';
            charCount.setAttribute('aria-live', 'polite');
            charCount.setAttribute('aria-atomic', 'true');
            
            if (helpText) {
                helpText.appendChild(document.createTextNode(' '));
                helpText.appendChild(charCount);
            }

            // 文字数を更新する関数
            function updateCharCount() {
                const currentLength = messageField.value.length;
                const remaining = maxLength - currentLength;
                
                // 翻訳テキストをdata属性から取得
                const currentLabel = messageField.getAttribute('data-char-count-current') || '現在';
                const remainingLabel = messageField.getAttribute('data-char-count-remaining') || '残り';
                const charactersLabel = messageField.getAttribute('data-char-count-characters') || '文字';
                
                // 言語に応じたフォーマット
                const currentLang = document.documentElement.lang || 'ja';
                if (currentLang === 'en') {
                    charCount.textContent = `(${currentLabel}: ${currentLength} ${charactersLabel} / ${remainingLabel}: ${remaining} ${charactersLabel})`;
                } else {
                    charCount.textContent = `（${currentLabel}: ${currentLength}${charactersLabel} / ${remainingLabel}: ${remaining}${charactersLabel}）`;
                }
                
                // 残り文字数が少なくなったら警告表示
                if (remaining < 50) {
                    charCount.classList.add('warning');
                } else {
                    charCount.classList.remove('warning');
                }
                
                if (remaining < 0) {
                    charCount.classList.add('error');
                } else {
                    charCount.classList.remove('error');
                }
            }

            // 初期状態でカウント表示
            updateCharCount();

            // 入力時にカウントを更新
            messageField.addEventListener('input', updateCharCount);
            messageField.addEventListener('keyup', updateCharCount);
        }
    });

    /**
     * ローディングインジケーターを追加
     */
    function addLoadingIndicator() {
        const form = document.querySelector('form[action="send.php"]');
        if (!form) return;

        // 既存のローディングインジケーターがあれば削除
        const existing = form.querySelector('.loading-indicator');
        if (existing) {
            existing.remove();
        }

        // ローディングインジケーターを作成
        const loader = document.createElement('div');
        loader.className = 'loading-indicator';
        loader.setAttribute('role', 'status');
        loader.setAttribute('aria-live', 'polite');
        loader.innerHTML = `
            <div class="spinner"></div>
            <p>お問い合わせを送信しています。しばらくお待ちください...</p>
        `;

        // フォームの前に挿入
        form.parentNode.insertBefore(loader, form);
    }
    function validateField(field, showFeedback) {
        if (!field) return true;

        const hint = document.querySelector(`.form-field-hint[data-field="${field.id}"]`);
        if (!hint) return true;

        const value = field.value.trim();
        let errorMessage = '';

        if (field.dataset.errorRequired && !value) {
            errorMessage = field.dataset.errorRequired;
        } else if (field.type === 'email' && value && field.dataset.errorEmail && !field.validity.valid) {
            errorMessage = field.dataset.errorEmail;
        }

        if (errorMessage) {
            hint.textContent = errorMessage;
            hint.classList.add('is-error');
            field.classList.add('error');
            return false;
        }

        if (showFeedback) {
            hint.textContent = '';
        }
        hint.classList.remove('is-error');
        field.classList.remove('error');
        return true;
    }
})();
